import React from 'react';
import SignIn from '../../../components/Registration/SignIn/SignIn';
const SignInPage = () => {

  return (
    
      <div className="signup-page">
      <SignIn/>
  </div>
  );
};

export default SignInPage;

